<template>
  <gj-modal
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      size="700XAuto"
      class="ad-copy"
      no-padding
      :content-style="{padding: '18px 80px 4px'}"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>复制广告活动</span>
    </template>
    <template #content>
      <el-row>
        <el-col :span="12" class="copy-cell">
          <span class="label">广告活动：</span>
          <span>{{ row.campaignName }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" class="copy-cell">
          <span class="label">站点：</span>
          <span>{{ adStore.SB.market.countryCode }}</span>
        </el-col>
        <el-col :span="12" class="copy-cell">
          <span class="label">店铺：</span>
          <span>{{ adStore.SB.market.name }}</span>
        </el-col>
      </el-row>
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="12" class="copy-cell">
            <el-form-item prop="marketId" label="复制到：" label-width="66px">
              <gj-select  v-loading="loading" size="mini" width="180px" v-model="form.marketId" :options="marketOptions" :clearable="false" @change="marketChange"></gj-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="copy-cell msg">注意站点的语种</el-col>
        </el-row>
      </el-form>
      <el-checkbox v-model="form.checked" :disabled="!AdCampaignEnum.SB.pause.support.includes(row.servingStatus)">创建后暂停当前广告活动</el-checkbox>
    </template>
  </gj-modal>
</template>

<script>
import {formRuleMixin, modalMixIn} from "@/minxins";
import { adStore } from "modules/ad/common/store";
import { AdCampaignEnum } from "modules/ad/common/enum";
import { listMarkets , listProductBrand } from "@/api/ad"

export default {
  name: 'ad-copy',
  mixins: [modalMixIn, formRuleMixin],
  props: {
    // 复制的广告活动信息
    row: {
      default: ()=> ({})
    }
  },
  data() {
    return {
      adStore,
      AdCampaignEnum,
      loading: false,
      marketOptions: [], // 站点枚举
      form: {
        marketId: null,
        checked: false
      },
      rules: {
        marketId: [
          { required: true, message: '请选择复制的站点', trigger: ['change']}
        ]
      },
    };
  },
  components: {},
  methods: {
    // 站点切换处理
    marketChange(marketId) {
      this.loading = true
      listProductBrand({ marketId })
        .then(({ data = [] }) => {
          if (data.length < 1) {
            this.$message.warning("抱歉，当前站点无品牌无法复制！")
            this.form.marketId = null
          }
        })
        .catch( err => {
          this.$message.warning("抱歉，当前站点无法复制！")
          this.form.marketId = null
        })
        .finally( () => {
          this.loading = false
        })
    },
    // 品牌广告-获取店铺站点信息下拉列表
    async listMarkets() {
      let params = {
        marketName: this.adStore.SB.market.name
      }
      let { data = {} } = await listMarkets(params)
      for (const key in data) {
        this.marketOptions.push({
          id: key,
          text: data[key],
          disabled: Boolean(this.row.adFormat == 1 && !AdCampaignEnum.SB.marketVideo.includes(data[key]))
        })
      }
    },
    // cancel() {},
    confirm() {
      let formValidate = this.$refs.form.validate()
      formValidate.then(res => {
        (res && !this.loading) && this.$gjModal.$gjDestroy();
        this.$emit("update", this.form, this.row)
      })
    },
  },
  created() {
    this.listMarkets()
  },
};
</script>

<style scoped lang='scss'>
.ad-copy {
  .copy-cell {
    padding: 8px;
    display: flex;
    font-size: 12px;
    .label {
      width: 66px;
      text-align: right;
      font-weight: 500;
      color: #333;
    }
    &.msg {
      color: #969696;
      padding-left: 39px;
    }
  }
  /deep/.el-form-item__label {
    padding-right: 0;
    color: #333;
    font-weight: 500;
  }
  /deep/.el-checkbox__label {
    font-size: 12px;
    padding-bottom: 25px;
  }
}
</style>